import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';
import { DEFAULT_ERROR_MESSAGE } from 'shared/enums/ErrorMessage';
import { getTranslations } from 'shared/utils/getTranslations';
import { NotFoundCollections } from 'error/components/NotFoundCollections';

export const Error = ({
  errorCode,
  errorMessage,
}: {
  errorCode: number | string;
  errorMessage?: string;
}) => {
  const defaultErrorMessage = getTranslations(DEFAULT_ERROR_MESSAGE);
  const message = errorMessage || defaultErrorMessage;

  return (
    <Error.Root>
      <h1 data-qa={`error_message_${errorCode}`}>{message}</h1>
      <div className="error-suggestion-container">
        <NotFoundCollections />
      </div>
    </Error.Root>
  );
};

Error.Root = styled.div`
  display: flex;
  min-height: calc(100vh - 216px);
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    margin-left: 169px;
  }

  & > h1 {
    font-weight: 600;
    text-align: left;
    margin: 0px 16px 72px;
    ${variableFontRegular({ size: '11.5px', height: '14px' })}
  }

  & div.error-suggestion-container {
    margin: 0 16px;
    max-width: 324px;
  }
`;
